module.exports = __webpack_public_path__ + "static/media/xlsx-icon.2b7c6821.svg";